export default __webpack_public_path__ + "static/media/big_plus.74f69ca8.svg";